// extracted by mini-css-extract-plugin
export default {"faqWrapper":"Faq_faqWrapper__mG5m1","faqContentWrapper":"Faq_faqContentWrapper__towL7","Container":"Faq_Container__Q1t4f","header":"Faq_header__Tb4PB"};